import type { ProjectReminder } from "@/types/Reminder";
import { confirmPopup } from "./Utility";
import { useAuthStore } from "@/stores/auth";
import type { DrawItem } from "@/types/DrawItem";

export const checkBudgetBasedReminders = (
  confirm: any,
  projectReminders: ProjectReminder[],
  items: DrawItem[],
  totalSiteCompletion: number,
  totalBudgetDrawn: number,
  processorId: string
) => {
  const userStore = useAuthStore();
  const userDetail = userStore.getUserInfo();

  const remindersToDisplay: ProjectReminder[] = [];

  projectReminders.forEach((projectReminder: ProjectReminder) => {
    if (!projectReminder.enabled || (projectReminder.privateReminder && processorId !== userDetail.entity)) return;

    if (projectReminder.percentCompleteSite !== -1 && totalSiteCompletion >= projectReminder.percentCompleteSite) {
      remindersToDisplay.push(projectReminder);
      return;
    }

    if (projectReminder.percentDrawnBudget !== -1 && totalBudgetDrawn >= projectReminder.percentDrawnBudget) {
      remindersToDisplay.push(projectReminder);
      return;
    }

    if (projectReminder.percentCompleteLineItem !== -1 || projectReminder.percentSite !== -1) {
      const lineItem = items.find((item: DrawItem) => item.lineRefNumber === projectReminder.lineItem);
      if (lineItem == null) return;

      if (lineItem.percentInspected >= projectReminder.percentCompleteLineItem) {
        remindersToDisplay.push(projectReminder);
        return;
      }

      if (lineItem.percentInspected >= totalSiteCompletion) {
        remindersToDisplay.push(projectReminder);
      }
    }
  });

  displayReminders(confirm, remindersToDisplay);
};

export const checkDrawReminders = (confirm: any, projectReminders: ProjectReminder[], drawNumber: number, processorId: string) => {
  const userStore = useAuthStore();
  const userDetail = userStore.getUserInfo();

  const remindersToDisplay: ProjectReminder[] = [];

  projectReminders.forEach((projectReminder: ProjectReminder) => {
    if (!projectReminder.enabled || (projectReminder.privateReminder && processorId !== userDetail.entity) || projectReminder.drawNumber === -1)
      return;

    if (drawNumber >= projectReminder.drawNumber) {
      remindersToDisplay.push(projectReminder);
    }
  });

  displayReminders(confirm, remindersToDisplay);
};

const displayReminders = (confirm: any, projectReminders: ProjectReminder[]) => {
  const projectReminder = projectReminders.pop();
  if (projectReminder == null) return;

  const dismissMessage = "Do you want to dismiss this reminder?";
  const reminderText =
    projectReminder.reminder.reminderText.length === 0 ? dismissMessage : projectReminder.reminder.reminderText + "\n\n" + dismissMessage;
  confirmPopup(
    confirm,
    projectReminder.reminder.reminderTitle,
    reminderText,
    () => {
      dismissReminder(projectReminder);
      setTimeout(() => displayReminders(confirm, projectReminders), 50);
    },
    () => {
      setTimeout(() => displayReminders(confirm, projectReminders), 50);
    }
  );
};

export const dismissReminder = async (projectReminder: ProjectReminder): Promise<boolean> => {
  let isSuccess: boolean = false;
  await axios
    .post(`/project-reminder/dismiss/${projectReminder.projectReminderId}`)
    .then((response) => {
      handleApiResponse(
        response,
        (data: any) => {
          success("Reminder Dismissed", "");
          projectReminder.enabled = false;
          isSuccess = true;
        },
        (errors: ApiError[]) => {
          error("Error Occurred", errors[0].message);
        }
      );
    })
    .catch((e) => errorApi(e));
  return isSuccess;
};
